
/**
 *
 * @callback onStartLoadingCallback
 * @returns {void}
 */
/**
 *
 * @callback onEndLoadingCallback
 * @returns {void}
 */
/**
 *
 * @callback onErrorCallback
 * @returns {void}
 */

/**
 * @class
 * @global
 * @param {string} elementSelector The jQuery selector of the element on which the initialise the cropper
 * @param {number} width The width of the crop box
 * @param {number} height The height of the crop box
 * @param {number} containerPadding The padding around the crop box
 * @param {boolean} allowVResize Whether resing of the crop box in the vertical direction is allowed
 * @param {boolean} allowHResize Whether resing of the crop box in the horizontal direction is allowed
 * @param {Array.<{classes: string, width: string, height: string}>} overlays An array of overlays to display over the image
 * @param {onStartLoadingCallback} onStartLoading A callback for the start loading event
 * @param {onEndLoadingCallback} onEndLoading A callback for the end loading event
 * @param {onErrorCallback} onErrorCallback A callback for the error event
 */
function CTCropper(elementSelector, width, height, containerPadding, allowVResize, allowHResize, overlays, onStartLoading, onEndLoading, onError)
{

	/** @type {Cropper} */
	this.cropper = null;
	/** @type {onStartLoadingCallback} */
	this.onStartLoading = onStartLoading;
	/** @type {onEndLoadingCallback} */
	this.onEndLoading = onEndLoading;
	/** @type {onErrorCallback} */
	this.onError = onError;
	/** @type {string} */
	this.elementSelector = null;
	/** @type {number} */
	this.width = null;
	/** @type {number} */
	this.height = null;
	/** @type {jQuery} */
	this.$image = null;
	/** @type {number} */
	this.containerPadding = null;
	/** @type {Array.<{classes: string, width: string, height: string}>} */
	this.overlays = overlays;
	/** @type {boolean}*/
	this.allowHResize = false;
	/** @type {boolean} */
	this.allowVResize = false;
	this.initialCanvasData = null;

	/**
	 * @param {number} scale
	 */
	this.getCroppedImageDataUrl = function (scale)
	{
		if (this.cropper === null)
			return null;
		if (typeof (scale) === "undefined")
			scale = 1;

		const cropBoxData = this.cropper.getCropBoxData();
		return this.cropper.getCroppedCanvas({
			width: cropBoxData.width * scale,
			height: cropBoxData.height * scale,
		}).toDataURL();
	}
	/**
	 * @return {Cropper}
	 */
	this.getCropper = function ()
	{
		return this.cropper;
	}

	this.resetCropBox = function ()
	{
		const cropBoxData = this.cropper.getCropBoxData();
		cropBoxData.width = this.width;
		cropBoxData.height = this.height;
		cropBoxData.left = this.containerPadding;
		cropBoxData.top = this.containerPadding;
		this.cropper.setCropBoxData(cropBoxData);
		this.cropper.setCanvasData(this.initialCanvasData);
	}
	/**
	 * @member
	 * @param {string} elementSelector The jQuery selector of the element on which the initialise the cropper
	 * @param {number} width The width of the crop box
	 * @param {number} height The height of the crop box
	 * @param {number} containerPadding The padding around the crop box
	 * @param {boolean} allowVResize Whether resing of the crop box in the vertical direction is allowed
	 * @param {boolean} allowHResize Whether resing of the crop box in the horizontal direction is allowed
	 * @param {Array.<{classes: string, width: string, height: string}>} overlays An array of overlays to display over the image
	 */
	this.reset = function (elementSelector, width, height, containerPadding, allowVResize, allowHResize, overlays)
	{

		this.elementSelector = elementSelector;
		this.width = width;
		this.height = height;
		this.$image = $(elementSelector);
		this.containerPadding = containerPadding;
		this.overlays = overlays;
		this.allowVResize = allowVResize;
		this.allowHResize = allowHResize;

		let self = this;
		this.$image.on('error', function (e)
		{
			if (typeof (self.onError) === "function")
				self.onError();
			if (typeof (self.onEndLoading) === "function")
				self.onEndLoading();
		});

		if (this.cropper !== null)
			this.cropper.destroy();

		if (typeof (this.onStartLoading) === "function")
			this.onStartLoading();
		this.cropper = new Cropper(this.$image[0], {
			viewMode: 0,
			dragMode: 'move',
			toggleDragModeOnDblclick: false,
			cropBoxMovable: false,
			cropBoxResizable: true,
			center: false,
			autoCrop: false,
			checkCrossOrigin: true,
			wheelZoomRatio: 0.1,
			// background: false,

			cropend(event)
			{
				const cropBoxData = self.cropper.getCropBoxData();

				if (cropBoxData.width > self.width || cropBoxData.height > self.height || !self.allowHResize || !self.allowVResize) {

					cropBoxData.width = self.allowHResize ? Math.min(cropBoxData.width, self.width) : self.width;
					cropBoxData.height = self.allowVResize ? Math.min(cropBoxData.height, self.height) : self.height;
				}

				const maxLeft = (self.containerPadding + self.width) - cropBoxData.width;
				const maxTop = (self.containerPadding + self.height) - cropBoxData.height;

				cropBoxData.left = Math.min(maxLeft, Math.max(self.containerPadding, cropBoxData.left));
				cropBoxData.top = Math.min(maxTop, Math.max(self.containerPadding, cropBoxData.top));

				self.cropper.setCropBoxData(cropBoxData);
			},
			ready(event)
			{
				const imageData = self.cropper.getImageData();

				self.cropper.crop();
				self.cropper.zoomTo(1);
				let data = {
					x: Math.floor((imageData.naturalWidth - self.width) / 2),
					y: Math.floor((imageData.naturalHeight - self.height) / 2),
					width: width,
					height: height,
					rotate: 0,
					scaleX: 1,
					scaleY: 1,
				};
				self.cropper.setData(data);

				let ratio = (width + (self.containerPadding * 2)) / imageData.naturalWidth;
				if (ratio < 1)
					self.cropper.zoomTo(ratio);

				self.initialCanvasData = this.cropper.getCanvasData();
				if (typeof (self.overlays) === 'object' && typeof (self.overlays.length) !== 'undefined') {
					for (var i = 0; i < self.overlays.length; i++) {
						$('.cropper-crop-box').append(
							"<div class='crop-box-overlay " + self.overlays[i].classes +
							"' style='width: " + self.overlays[i].width + "; height: " + self.overlays[i].height +
							";'></div>");
					}
				}

				if (typeof (self.onEndLoading) === "function")
					self.onEndLoading();

			}
		});
	}

	this.reset(elementSelector, width, height, containerPadding, allowVResize, allowHResize, overlays);
}
